import { render, staticRenderFns } from "./reg_login.vue?vue&type=template&id=43fb9bf5&scoped=true"
import script from "./reg_login.vue?vue&type=script&lang=js"
export * from "./reg_login.vue?vue&type=script&lang=js"
import style0 from "./reg_login.vue?vue&type=style&index=0&id=43fb9bf5&lang=css"
import style1 from "./reg_login.vue?vue&type=style&index=1&id=43fb9bf5&lang=css"
import style2 from "./reg_login.vue?vue&type=style&index=2&id=43fb9bf5&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fb9bf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43fb9bf5')) {
      api.createRecord('43fb9bf5', component.options)
    } else {
      api.reload('43fb9bf5', component.options)
    }
    module.hot.accept("./reg_login.vue?vue&type=template&id=43fb9bf5&scoped=true", function () {
      api.rerender('43fb9bf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/landingpage/reg_login.vue"
export default component.exports